import React from 'react';
import styles from './css/VisitWebsiteLink.styl';
import {formatExternalLink} from '../../../../../../appModules/utilities/formatHelpers';
import SVGIcon from '../../../../../../assets/svg-icons/icons';
import {getGATags} from '../../../../../shared/utilities/GAHelpers';

const VisitWebsiteLink = props => {
  const formattedUrl = formatExternalLink(props.websiteUrl);

  if (!formattedUrl) {
    return null;
  }

  const handleClick = () => {
    getGATags({
      eventCategory: 'fhd_fhweb',
      eventAction: 'fhd_fhweb_click',
      eventLabel: 'fhd_website',
    });
  };

  return (
    <div className={styles.VisitWebsiteLink}>
      <SVGIcon name="globe" fill="#069" size="16" />
      <a
        className={styles.Link}
        data-ga-no-auto-tag
        href={formattedUrl}
        onClick={handleClick}
        target="_blank"
      >
        Visit Our Website
      </a>
    </div>
  );
};

VisitWebsiteLink.propTypes = {
  websiteUrl: React.PropTypes.string,
};

export default VisitWebsiteLink;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Shared/VisitWebsiteLink/index.js